/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DepositItemsResponse = {
    /**
     * Whether the deposit was successfully created
     */
    success: boolean;
    deposit: {
        /**
         * Internal order ID
         */
        orderId: string;
        /**
         * Skinsback transaction ID
         */
        transactionId: string;
        /**
         * Steam trade offer ID
         */
        tradeOfferId: string;
        /**
         * Trade offer expiration timestamp
         */
        tradeOfferExpiryAt: string;
        bot: {
            /**
             * Bot Steam ID
             */
            steamId: string;
            /**
             * Bot display name
             */
            name: string;
        };
        amounts: {
            /**
             * Original deposit amount in cents
             */
            original: number;
            /**
             * Amount with bonus applied in cents
             */
            withBonus: number;
        };
        /**
         * Deposit status
         */
        status: DepositItemsResponse.status;
    };
};
export namespace DepositItemsResponse {
    /**
     * Deposit status
     */
    export enum status {
        PENDING = 'pending',
    }
}

